/**
 * Текущее содержимое очереди как React-состояние.
 *
 * Три экрана (задания, карточка байка, карта) подписываются на очередь одним
 * и тем же способом — вынесено сюда, чтобы не разойтись в паттерне. Не в
 * `outbox.ts` самом: тот — чистый модуль без React, и подписчиков у него
 * может быть больше одного вида (см. `app/providers.tsx`, где догрузка
 * очереди — не хук, а прямая подписка).
 *
 * ─────────────────────────────────────────────────────────────────────────
 * ⚠ `null` — ЭТО «ЕЩЁ НЕ ЗНАЮ», И ОН НЕ РАВЕН ПУСТОЙ ОЧЕРЕДИ
 * ─────────────────────────────────────────────────────────────────────────
 * `subscribeOutbox` отвечает асинхронно: внутри `readOutbox()`, то есть
 * чтение IndexedDB. Первый кадр КАЖДОГО монтирования экрана проходит без
 * ответа — не только холодный старт.
 *
 * Пока хук отдавал на этом кадре `[]`, читатель не мог отличить «очередь
 * пуста» от «я ещё не спросил», и решение принималось на незнании. Цена
 * была настоящая: карта на первом кадре считала, что неотправленных смен
 * статуса нет, и снимала отметку «Забираю» с байка, чью смену статуса
 * только что положили в очередь (`lib/pickup-selection.ts`). Снять отметку
 * можно, вернуть — некому.
 *
 * Читателям, которым разница не важна (бейдж «N не отправлено», проверка
 * «задача уже в очереди»), достаточно `?? []` на месте вызова — их
 * поведение от этого не меняется.
 */
import { useEffect, useState } from 'react'
import { subscribeOutbox, type OutboxEntry } from './outbox'

export function useOutboxEntries(): OutboxEntry[] | null {
  const [entries, setEntries] = useState<OutboxEntry[] | null>(null)
  useEffect(() => subscribeOutbox(setEntries), [])
  return entries
}
